import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useRootContext } from '../partials/context/rootContext';
import { HashRouter, Route, Switch, Link } from 'react-router-dom';
import moment from 'moment-timezone';

import Landing from './landing';
import EventRsvp from './eventRsvp';
import MainSession from './mainSession';
import AfterEvent from './afterEvent';
import Breakouts from './breakouts';
import ExpressSupport from './expressSupport';
import RegionChange from "./regionChange"
import ChatLogs from "./chatLogs"

const Router = ({...routerProps}) => {
    const { registerContext } = useRootContext();
    const [eventsToday, setEventsToday] = useState(false);
    const [eventHasEnded, setEventHasEnded] = useState(false);
    
    useEffect(() => {
        const today = moment.tz('America/New_York');
        const eventEnd = moment(routerProps.data.event.end);
        const roomsToday = routerProps.data.rooms.filter((room) => {return today.isSame(moment(room.start), 'day');});      


        setEventsToday(roomsToday.length > 0);
        setEventHasEnded(eventEnd.diff(today) < 0);
    },[])

    return (
        <Switch>

            <Route path="/" exact render={props => {
                if(eventHasEnded) return <AfterEvent {...props} {...routerProps} />;
                return routerProps.showRSVP ? (
                    <EventRsvp {...props} {...routerProps} />
                ) : (
                    routerProps.data.attendee.location ? //if no region is set. show the region change page
                        eventsToday ? 
                            <MainSession {...props} {...routerProps} /> 
                            : <Landing {...props} {...routerProps} /> 
                    : <RegionChange {...props} {...routerProps} />
                );
            }} />

            <Route path="/home" exact render={props => <MainSession {...props} {...routerProps} />} />
            <Route path="/breakouts" exact render={props => <Breakouts {...props} {...routerProps} />} />
            <Route path="/expressSupport" exact render={props => <ExpressSupport {...props} {...routerProps} />} />
            <Route path="/regionChange" exact render={props => <RegionChange {...props} {...routerProps} />} />
            <Route path="/chatLogs" exact render={props => <ChatLogs {...props} {...routerProps} />} />
        </Switch>
    );
};

export default Router;
